import { agendar } from "@/components/home/rubro";

// ---------------------------------------------------------------------------
// FINAL CTA — "El primer trabajo que recuperes paga el sistema."
// Shared closing section used across pages.
// ---------------------------------------------------------------------------

export function FinalCta() {
  return (
    <section
      data-screen-label="CTA"
      className="relative overflow-hidden border-t border-[#221F2A]"
    >
      <div
        className="absolute left-1/2 top-full pointer-events-none"
        style={{
          width: 1100,
          height: 700,
          transform: "translate(-50%,-50%)",
          borderRadius: "50%",
          background:
            "radial-gradient(circle,rgba(139,92,246,0.14),transparent 60%)",
        }}
      />
      <div
        className="relative mx-auto px-6 text-center flex flex-col items-center gap-[22px]"
        style={{
          maxWidth: 1000,
          paddingTop: "clamp(96px,12vw,160px)",
          paddingBottom: "clamp(96px,12vw,160px)",
        }}
      >
        <h2
          className="font-medium text-[#EEEDF2]"
          style={{
            fontSize: "clamp(40px,6vw,84px)",
            lineHeight: 1,
            letterSpacing: "-0.03em",
            textWrap: "balance" as never,
          }}
        >
          El primer trabajo que recuperes{" "}
          <span
            style={{
              background: "linear-gradient(90deg,#A78BFA,#E879F9)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}
          >
            paga el sistema.
          </span>
        </h2>
        <p
          className="text-[#BAB6C4]"
          style={{
            fontSize: 18,
            lineHeight: 1.55,
            maxWidth: 560,
            textWrap: "pretty" as never,
          }}
        >
          Llamada de 20 minutos. Te mostramos cuentas reales andando y te
          decimos con honestidad si te sirve.
        </p>
        <div className="flex gap-3 flex-wrap justify-center mt-2">
          <button
            onClick={() => agendar("Cierre - Agendar llamada")}
            className="bg-[#7C3AED] hover:bg-[#8B5CF6] text-white font-semibold rounded-[10px] transition-colors"
            style={{ padding: "16px 26px", fontSize: 16 }}
          >
            Agendar una llamada
          </button>
          <a
            href="https://wa.me/5491123729528?text=Vengo%20de%20la%20web%20y%20tengo%20una%20duda"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-[#332E3E] rounded-[10px] font-medium text-[#EEEDF2] hover:bg-[#1A1530] transition-colors inline-flex items-center"
            style={{ padding: "16px 26px", fontSize: 16 }}
          >
            Escribir por WhatsApp
          </a>
        </div>
        <div className="font-mono text-[13px] text-[#9C98A6]">
          sin contrato · garantía de 30 días
        </div>
      </div>
    </section>
  );
}
